import * as types from './actionTypes';

export function setSubmissionsType(val) {
  return {type: types.SET_SUBMISSIONS_TYPE, setToVal: val};
}
